<template>
  <div class="subject">
    <div class="content">
      <div class="tit">1-1上课注意事项直播试题</div>
      <li v-for="(item,index) in 10" :key="index">
        <div class="top">1.新生儿一出生就具有？ (单选)</div>
        <el-radio-group
          fill="#000000"
          v-model="radio">
          <el-radio :label="3">备选项</el-radio>
          <el-radio :label="6">备选项</el-radio>
          <el-radio :label="9">备选项</el-radio>
        </el-radio-group>
      </li>
      <li>
        <div class="top">2.亲子课程中认知环节的一般流程为？ (多选)</div>
        <el-checkbox-group
          fill="red"
          v-model="checkList">
          <el-checkbox label="复选框 A"></el-checkbox>
          <el-checkbox label="复选框 B"></el-checkbox>
          <el-checkbox label="复选框 C"></el-checkbox>
        </el-checkbox-group>
      </li>
      <li>
        <div class="top">3.亲子课程中认知环节的一般流程为？ (多选)</div>
        <el-checkbox-group
          fill="red"
          v-model="checkList">
          <el-checkbox label="复选框 A"></el-checkbox>
          <el-checkbox label="复选框 B"></el-checkbox>
          <el-checkbox label="复选框 C"></el-checkbox>
        </el-checkbox-group>
      </li>
      <li>
        <div class="top">4.亲子课程中认知环节的一般流程为？ (多选)</div>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="textarea">
        </el-input>
      </li>
      <div class="sure">提交</div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        radio: '1',
        checkList: ['复选框 A', '复选框 B'],
        resource: ''
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .subject {
    width: 1140px;
    height: 80%;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 10%;
    margin-left: -600px;
    border-radius: 30px;
    padding: 0 30px;

    .content {
      overflow-x: hidden;
      overflow-y: scroll;
      height: 100%;
      position: relative;

      &::-webkit-scrollbar {
        display: none;
      }

      .sure {
        margin: 20px auto;
        border-radius: 10px;
        cursor: pointer;
        width: 200px;
        height: 40px;
        line-height: 40px;
        background-color: #ff8484;
        text-align: center;
        color: #fff;
      }
    }

    .tit {
      font-size: 20px;
      text-align: center;
      margin: 40px auto 0;
    }

    .el-radio-group {
      .el-radio__input.is-checked .el-radio__inner {
        border-color: #ff8484;
        background: #ff8484;
      }

      .el-radio__input .el-radio__inner {
        &:hover {
          border: 1px solid #ff8484;
        }
      }

      .el-radio__input.is-checked + .el-radio__label {
        color: #ff8484;
      }
    }

    .el-checkbox-group {
      .el-checkbox__input.is-checked .el-checkbox__inner {
        border-color: #ff8484;
        background: #ff8484;
      }

      .el-checkbox__input .el-checkbox__inner {
        &:hover {
          border: 1px solid #ff8484;
        }
      }

      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #ff8484;
      }
    }

    li {
      overflow: hidden;
      text-align: left;
      font-size: 16px;
      margin-top: 20px;

      .top {
        margin: 10px auto;
      }

      textarea {
        &:focus {
          border: 1px solid #ff827b;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/liveLayer/subject/subject.vue